export enum ELocalStorage {
  Token = 'token',
  User = 'user',
  AwsTokenExpirationTime = 'aws-token-expiration-time',
}
